/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_EditorInputs */

const cs_workflow_editor = /** @type {(inputs: Workflow_EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editor workflow`)
};

const en_workflow_editor = /** @type {(inputs: Workflow_EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workflow editor`)
};

/**
* | output |
* | --- |
* | "Workflow editor" |
*
* @param {Workflow_EditorInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_editor = /** @type {((inputs?: Workflow_EditorInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_EditorInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_editor(inputs)
	return cs_workflow_editor(inputs)
});